import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/reconnaitre-objet-valeur-rachat/PageClient.jsx");
